import { OnDestroy, Injectable, Directive } from '@angular/core';
import { SynchronizationService } from '../synchronization.service';
import { Subscription } from 'rxjs';
import { ReleaseplanningSprintColumn } from
  '../../components/releaseplanning/releaseplanning-sprint-column/releaseplanning-sprint-column.component';
import { SyncEventType } from '../../models/enums/syncEventType';
import { Sprint } from '../../models/sprint';
import { EventSprintUpdated } from '../../models/syncEvents/persistenceEvents/eventSprintUpdated';
import { EventIssueUpdated } from '../../models/syncEvents/persistenceEvents/eventIssueUpdated';

/**
 * this service is handling sync-Events for MPCBoardSprint-Component
 */
@Directive()
export class ReleaseplanningSyncService implements OnDestroy {

  private subscriptions: Subscription[] = [];
  private sprintColumn: ReleaseplanningSprintColumn;

  constructor(
    private syncService: SynchronizationService) {
  }

  ngOnDestroy(): void {
    for (const ev of this.subscriptions) {
      ev.unsubscribe();
    }
  }

  public init(sprintColumn: ReleaseplanningSprintColumn) {
    this.sprintColumn = sprintColumn;
    this.syncService.joinPersistenceRoom(this.sprintColumn.projectKey);
    this.subscribeToSprintUpdatedEvent();
    this.subscribeToIssueUpdated();
  }

  private subscribeToSprintUpdatedEvent(): void {
    this.subscriptions.push(this.syncService.subscribeEvent<Sprint>(SyncEventType.SPRINT_UPDATED).subscribe(
      payload => {
        const event = EventSprintUpdated.fromPayload(payload);
        if (event.sprint.id === this.sprintColumn.sprint.id) {
          this.sprintColumn.sprint = event.sprint;
        }
      }
    ));
  }

  private subscribeToIssueUpdated(): void {
    this.subscriptions.push(this.syncService.subscribeEvent<Sprint>(SyncEventType.ISSUE_UPDATED).subscribe(
      payload => {
        const event = EventIssueUpdated.fromPayload(payload);
        if (event.sprintId && event.sprintId === this.sprintColumn.sprint.id) {
          console.log('issue updated in RP. sprint ', this.sprintColumn.sprint.id);
          // TODO implement moving issue to this sprint or upating it if already in this sprint
        }
      }
    ));
  }


}
